import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import AWS from 'aws-sdk'
import Fuse from 'fuse.js'
import Control from '@/helpers/control'

library.add(faClose, faTrashAlt)

const bucketName = 'portal-conteudos-laminas'
const bucketRegion = 'sa-east-1'
const IdentityPoolId = 'sa-east-1:bc7f9ff6-d461-4870-b480-29756e9502e9'

let s3 = null as any

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class CreateModal extends Vue {
	@Prop({ required: true }) tags!: Array<any>
	@Prop({ required: true }) laminaId!: [number, string]

	modalLoading = false
	submitLoading = false
	savingTag = false
	saving = false
	control = new Control()
	form = {
		id: '',
		title: '',
		desc: '',
		url: '',
		file: null as unknown as File,
		tag: '',
		content_tags: [] as Array<any>,
	}

	awsSetup() {
		AWS.config.update({
			region: bucketRegion,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: IdentityPoolId,
			}),
		})

		s3 = new AWS.S3({
			apiVersion: '2006-03-01',
			params: { Bucket: bucketName },
		})
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	onInput(name, value) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value)
		}, 1000)
		debouncedChange()
	}

	async save(name, value) {
		const update = {}
		update[name] = value
		this.saving = true
		const res = await api.post(
			'/api/blogging/content-laminas/' + this.form.id,
			update,
		)
		this.saving = false

		if (res.ok) {
			this.successToast()
		} else {
			this.errorToast()
		}
	}

	clearForm() {
		this.form.title = ''
		this.form.desc = ''
		this.form.url = ''
		this.form.id = ''
		this.form.file = null as unknown as File
		this.form.content_tags = []
		this.modalLoading = false
		this.$emit('hidden')
	}

	async addTag() {
		if (!this.form.tag) return
		const tag = this.tags.find((tag) => tag.id === this.form.tag)

		this.savingTag = true
		const res = await api.post(
			'/api/blogging/content-laminas/' + this.form.id + '/content-tags',
			{ tag: this.form.tag },
		)
		if (res.ok) {
			this.form.content_tags.push({
				mapId: res.data.id,
				tag: {
					name: tag.name,
					id: tag.id,
				},
				loading: false,
			})
			this.form.tag = ''
		} else {
			this.$bvToast.toast(
				'Não foi possível associar tag, verifique se a tag já não está associada',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
		this.savingTag = false
	}

	async removeTag(tagMap, index) {
		tagMap.loading = true
		const res = await api.delete(
			'/api/blogging/content-laminas/' + this.form.id + '/content-tags',
			{ mapId: tagMap.mapId },
		)
		if (res.ok) {
			this.form.content_tags.splice(index, 1)
		}
		tagMap.loading = false
	}

	uploadPdf(callback) {
		const emptyPdfUrl = ''

		// timestamp-randomString_originalFilename
		const fileName =
			Date.now() +
			'-' +
			Math.round(Math.random() * 1e5) +
			'_' +
			this.form.file.name

		s3.upload(
			{
				Bucket: bucketName,
				Key: fileName,
				Body: this.form.file,
				ContentType: this.form.file.type,
			},
			(err, data) => {
				/**
				 * data: {
				 *   Bucket, (bucket name)
				 *   ETag, (random string)
				 *   Key, (filename)
				 *   Location, (full url)
				 *   key, (filename)
				 * }
				 */
				if (err) {
					this.$bvToast.toast(
						'Não foi possível fazer upload do pdf. ' + err,
						{
							title: 'Erro',
							variant: 'danger',
							solid: true,
							toaster: 'b-toaster-top-center',
						},
					)
				} else {
					callback(data.Location)
				}
			},
		)
	}

	async replacePdf() {
		if (!(this.form.file instanceof File)) {
			this.$bvToast.toast('Selecione um arquivo', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			return false
		}

		this.submitLoading = true
		this.uploadPdf(async (pdfUrl) => {
			const res = await api.post(
				'/api/blogging/content-laminas/' + this.form.id,
				{
					url: pdfUrl,
				},
			)
			this.submitLoading = false
			if (res.ok) {
				this.successToast()
				this.form.url = pdfUrl
			} else {
				this.$bvToast.toast(res.msg, {
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				})
			}
		})
	}

	successToast() {
		this.$bvToast.toast('Lâmina Atualizada!', {
			title: 'Sucesso!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	errorToast() {
		this.$bvToast.toast(
			'Tivemos um erro, entre em contato com a area de T.I.',
			{
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			},
		)
	}

	async loadLamina() {
		this.modalLoading = true
		await this.$nextTick()
		const res = await api.get(
			'/api/blogging/content-laminas/' + this.laminaId,
		)

		if (res.ok) {
			Object.assign(res.data, { loading: false })
			res.data.content_tags = res.data.content_tags.map((tagMap) => {
				Object.assign(tagMap, { loading: false })
				return tagMap
			})
			Object.assign(this.form, res.data)
		} else {
			this.$bvToast.toast(res.msg, {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}

		this.modalLoading = false
	}

	mounted() {
		this.awsSetup()
	}
}
